import { KEYBOARD_SHORTCUTS } from 'src/interfaces/enums';

export const allowedKeyshortcutsPropagation = [
  KEYBOARD_SHORTCUTS.TOGGLE_FULLSCREEN,
  KEYBOARD_SHORTCUTS.TOGGLE_PLAY_ALTERNATIVE,
  KEYBOARD_SHORTCUTS.TOGGLE_SUBTITLE,
  KEYBOARD_SHORTCUTS.CLOSE_FLOATING_OVERLAY,
];
